module.exports = __webpack_public_path__ + "img/menu-5.890617bd.jpg";